export default __webpack_public_path__ + "static/media/scheduler.405187c0.jpg";